<template>
  <header>
    <nav class="navbar navbar-expand-md" :class="{ 'navbar--fixed': scrolled }" ref="navbar">
      <div class="container">
        <router-link :to="{ name: 'home' }" class="navbar-brand">
          <img src="@/assets/images/logo.png" alt="Mixdorf Logo" class="logo"/>
          <span class="navbar-brand__label">Mixdorf</span>
        </router-link>
        <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
          <span class="icon-bar top-bar"></span>
          <span class="icon-bar middle-bar"></span>
          <span class="icon-bar bottom-bar"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div class="navbar-nav">
              <router-link :to="{ name: 'clubs' }" class="nav-link"
              >Vereine
              </router-link
              >
              <button class="nav-link" @click="logout()" v-if="userIsLogged">Logout</button>
            </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script setup>
import {ref, onBeforeMount, onMounted, defineExpose} from 'vue';
import {useRouter} from 'vue-router';

const navbar = ref(null);
const scrolled = ref(false);
const userIsLogged = ref(false);
const lastPosition = ref(0);
const router = useRouter();

const handleScroll = () => {
  if (navbar.value.offsetTop < window.pageYOffset) {
    scrolled.value = true;
  } else {
    scrolled.value = false;
  }
  lastPosition.value = window.scrollY;
};

const logout = () => {
  localStorage.removeItem("userCheckResult");
  checkUserLogged();
  router.push({name: 'login'});
};

const checkUserLogged = () => {
  userIsLogged.value = localStorage.getItem("userCheckResult");
};

onBeforeMount(() => {
  window.addEventListener("scroll", handleScroll);
});

onMounted(() => {
  checkUserLogged();
});

// ✅ This works inside <script setup>
defineExpose({
  checkUserLogged
});
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
